import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

import { MathEnabledTextComponent, styleVariables } from '@lib/common';
import { styled } from '@xstyled/styled-components';
import { Space, Typography } from 'antd';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Paragraph = Typography.Paragraph;
var SectionCard = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 40px 16px 16px 16px;\n  width: 100%;\n  border-radius: 8px;\n\n  background-color: ", ";\n\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.12);\n  ", "\n"])), styleVariables.colors.gray1, function (props) {
  return props.theme.media.desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 40px;\n  "])));
});
var Header = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  ", "\n"])), function (props) {
  return props.theme.media.desktop(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    \n  "])));
});
var TitleArea = styled(Space)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var Title = styled.label(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 32px;\n"])));
var Score = styled.label(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: ", ";\n"])), styleVariables.colors.gray11);
var Description = styled(Paragraph)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  &.ant-typography {\n    margin-top: 16px;\n    margin-bottom: 0;\n\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n\n    color: ", ";\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n  }\n  img {\n    max-width: 100%;\n  }\n"])), styleVariables.colors.gray13);
export var SubmissionSectionPreview = function SubmissionSectionPreview(_ref) {
  var section = _ref.section,
      index = _ref.index,
      isShowingScore = _ref.isShowingScore,
      totalCorrectAnswer = _ref.totalCorrectAnswer,
      label = _ref.label,
      children = _ref.children;

  var renderScore = function renderScore() {
    return isShowingScore && /*#__PURE__*/_jsxs(Score, {
      children: [totalCorrectAnswer, "/", section.totalQuestion, " ", label.numberOfCorrectAnswer]
    });
  };

  return /*#__PURE__*/_jsxs(SectionCard, {
    direction: "vertical",
    children: [/*#__PURE__*/_jsx(Header, {
      children: /*#__PURE__*/_jsxs(TitleArea, {
        direction: "horizontal",
        size: "middle",
        children: [/*#__PURE__*/_jsxs(Title, {
          children: [label.section, " ", index]
        }), renderScore()]
      })
    }), /*#__PURE__*/_jsx(Description, {
      children: /*#__PURE__*/_jsx(MathEnabledTextComponent, {
        value: section.description
      })
    }), /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })]
  });
};